var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2268_282",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2268_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.375 14.875H3.54167C3.15208 14.875 2.81858 14.7363 2.54115 14.4589C2.26372 14.1814 2.125 13.8479 2.125 13.4583V8.5C2.125 7.61458 2.29323 6.78524 2.62969 6.01198C2.96615 5.23872 3.42066 4.5658 3.99323 3.99323C4.5658 3.42066 5.23872 2.96615 6.01198 2.62969C6.78524 2.29323 7.61458 2.125 8.5 2.125C9.38542 2.125 10.2148 2.29323 10.988 2.62969C11.7613 2.96615 12.4342 3.42066 13.0068 3.99323C13.5793 4.5658 14.0339 5.23872 14.3703 6.01198C14.7068 6.78524 14.875 7.61458 14.875 8.5V13.4583C14.875 13.8479 14.7363 14.1814 14.4589 14.4589C14.1814 14.7363 13.8479 14.875 13.4583 14.875H10.625V9.20833H13.4583V8.5C13.4583 7.11875 12.9773 5.94705 12.0151 4.9849C11.053 4.02274 9.88125 3.54167 8.5 3.54167C7.11875 3.54167 5.94705 4.02274 4.9849 4.9849C4.02274 5.94705 3.54167 7.11875 3.54167 8.5V9.20833H6.375V14.875ZM4.95833 10.625H3.54167V13.4583H4.95833V10.625ZM12.0417 10.625V13.4583H13.4583V10.625H12.0417Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.8ec09f88a84a33146429776dfc79cc4a.svg";
export { ForwardRef as ReactComponent };